import React from "react";
import {injectIntl} from "react-intl";
import {RestMS} from "./controllers/ms-rest-api";
import {testLoadAutoplay} from "./utils/utils";
import {getPanelType, hasPanel} from "./utils/panel-helper";
import MsFeedbackMessage from "../widgets/ms-feedback-message.jsx";
import MSTimer from "../widgets/ms-timer.jsx";
import ClapprPlayer from "./clappr-player.jsx";
import TinodeWeb from "../views/tinode-web.jsx";
import MSPanels from "./ms-panels.jsx";
import MSStreamLoader from "../widgets/ms-stream-loader.jsx";
import MSStreamError from "../widgets/ms-stream-error.jsx";
import {PACKAGE_VERSION as PACKAGE_VERSION} from '../version';

import {translations} from "./translations";

class MsVideoPlayer extends React.Component {
    constructor(props) {
        super(props);
        this.jsonEng = JSON.parse(atob(this.props.jsonPayload.vm_wsh));
        this.restMS = new RestMS(
            this.props.jsonPayload.app,
            this.props.jsonPayload.stream,
            this.props.jsonPayload.pingId,
            this.jsonEng
        )
        this.checkHash = null;
        this.checkRunning = null;
        this.checkActive = null;
        this.maxAttempts = 4;
        this.source = this.props.jsonPayload.source;
        this.autoLoad = 'DISABLE'
        this.state = {
            embeddedChecked: false,
            showLoader: true,
            showTimer: false,
            showChat: true,
            showPanels: false,

            streamUnavailable: false,
            unavailableTitle: translations.emd_player.stream_unavailable.title,
            unavailableMessage: translations.emd_player.stream_unavailable.msg,

            streamState: 'none',
            showError: false,
            errorId: "",
            attempts: 0,
            playerKey: 0,
            maximized: false,

        };
        this.typeStreamData = {
            ecomm: false,
            wcdata: false,
            streamType: 'free'
        }
        this.getStreamSettings = this.getStreamSettings.bind(this);
        this.loadPlayer = this.loadPlayer.bind(this);
        this.loadPlayerEmbedded = this.loadPlayerEmbedded.bind(this);
        this.showChat = this.showChat.bind(this);
        this.toggleMaximize = this.toggleMaximize.bind(this);
        this.startPlayer = this.startPlayer.bind(this);
        this.displayErrorScreen = this.displayErrorScreen.bind(this);
        this.setCheckErrorScreen = this.setCheckErrorScreen.bind(this);
        this.checkActiveStream = this.checkActiveStream.bind(this);
        this.clearAllInterval = this.clearAllInterval.bind(this);
        this.hidePlayerEmbedded = this.hidePlayerEmbedded.bind(this);
        this.errorCounterFinish = this.errorCounterFinish.bind(this);
    }

    componentDidMount() {
        if (this.props.embedded) {
            this.getStreamSettings();
        } else {
            this.restMS.setTypeStream('free');
            this.loadPlayer();
        }
    }

    componentWillUnmount() {
        this.clearAllInterval();
    }

    clearAllInterval() {
        clearInterval(this.checkRunning);
        this.checkRunning = null;
        clearInterval(this.checkHash);
        this.checkHash = null;
        clearInterval(this.checkActive);
        this.checkActive = null;
    }

    checkActiveStream() {
        let self = this;
        self.clearAllInterval();
        // check active stream here
        this.restMS.pingStream(
            (resp) => {
                console.log(resp);
                console.log('stream test---->>');
                console.log(this.state.streamState);
                console.log(this.state);
                console.log('isActive', resp, 'streamState', this.state.streamState);

                if (!resp) {
                    if (this.state.streamState != 'timer') {
                        clearInterval(this.checkRunning);
                        this.checkRunning = null;
                        this.clearAllInterval();
                        this.setState({
                            showLoader: false, showTimer: true, showPanels: false,
                            streamState: 'timer', showError: false
                        });
                    }
                    clearInterval(this.checkRunning);
                    this.checkRunning = null;
                    self.clearAllInterval();
                    this.checkActive = setInterval(() => {
                        this.checkActiveStream();
                    }, 3000);
                } else {
                    // console.log('-------------> test startPlayer');
                    if (this.state.streamState == 'inactive') {
                        clearInterval(this.checkRunning);
                        this.checkRunning = null;
                        self.clearAllInterval();
                        this.checkActive = setInterval(() => {
                            this.checkActiveStream();
                        }, 10000);
                    }
                    clearInterval(this.checkRunning);
                    this.checkRunning = null;
                    self.clearAllInterval();
                    this.startPlayer();
                }
            },
            (err) => {
                if (this.state.streamState == 'offline') {
                    // console.log('----------> IS OFFLINE');
                    clearInterval(this.checkRunning);
                    this.checkRunning = null;
                    self.clearAllInterval();
                    this.checkActive = setInterval(() => {
                        this.checkActiveStream();
                    }, 5000);
                } else {
                    // clearInterval(this.checkRunning);
                    // this.checkRunning = null;
                    // self.clearAllInterval();
                    // this.displayErrorScreen('internet_error', 'gotError');
                }
            }
        );
    }

    async loadPlayer() {
        try {
            this.autoLoad = await testLoadAutoplay();
        } catch (e) {
            this.autoLoad = 'DISABLE';
        }

        this.restMS.pingStream(
            (resp) => {
                if (resp) {
                    if (this.props.embedded && !this.state.embeddedChecked) {
                        this.restMS.getStreamData((resp) => {
                                if (!resp || resp == "") {
                                    this.setState({
                                        streamUnavailable: true,
                                        unavailableTitle: translations.emd_player.config_changed.title,
                                        unavailableMessage: translations.emd_player.config_changed.msg
                                    });
                                } else {
                                    this.source = atob(resp.data.k);
                                    this.startPlayer();
                                }
                            },
                            (err) => {
                                this.setState({
                                    streamUnavailable: true,
                                    unavailableTitle: translations.emd_player.config_changed.title,
                                    unavailableMessage: translations.emd_player.config_changed.msg
                                });
                            }
                        );
                    } else {
                        this.startPlayer();
                    }
                } else {
                    this.setState({
                        showLoader: false, showTimer: true, showPanels: false,
                        showError: false, streamState: 'timer'
                    });
                    this.checkActiveStream();
                }
            },
            (err) => {
                this.setState({
                    streamUnavailable: true,
                    unavailableTitle: translations.emd_player.server_notresp.title,
                    unavailableMessage: translations.emd_player.server_notresp.msg
                });
            }
        );
    }

    getStreamSettings() {
        clearInterval(this.checkHash);
        this.checkHash = null;
        console.log('-----> calling the stream ');
        let promise = this.restMS.getRestRequest('vs', {
            hash: this.props.hash
        });

        console.log('stream connection data');

        if (promise) {
            promise
                .then((response) => {
                    let resp = response.data;

                    console.log('payload from the member-streaming');
                    console.log(resp);
                    console.log(this.props.jsonPayload);

                    if (resp.success && resp.is_ok) {
                        // valid hash
                        if (hasPanel(this.props.jsonPayload.type)) {
                            this.typeStreamData = getPanelType(this.props.jsonPayload.type);
                            this.restMS.setTypeStream(this.typeStreamData.streamType);
                            this.setState({
                                showLoader: false, showTimer: false, showPanels: true,
                                showError: false
                            });
                        } else {
                            this.restMS.setTypeStream('free');
                            this.loadPlayer();
                        }
                    } else {
                        // handle invalid hash
                        if (resp.hasOwnProperty('resp')) {
                            this.setState({
                                streamUnavailable: true,
                                unavailableTitle: translations.emd_player.stream_unavailable.title,
                                unavailableMessage: translations.emd_player.stream_unavailable.msg
                            });
                        } else {
                            // some other error
                            this.setState({
                                showLoader: false, showTimer: true, showPanels: false,
                                showError: false, streamState: 'timer'
                            });
                            this.checkHash = setInterval(() => {
                                this.getStreamSettings(this.props.hash);
                            }, 3000);
                        }
                        // end
                    }
                })
                .catch((error) => {
                    console.log('here 5', error);
                    this.setState({
                        streamUnavailable: true,
                        unavailableTitle: translations.emd_player.stream_unavailable.title,
                        unavailableMessage: translations.emd_player.stream_unavailable.msg
                    });
                });
        }
    }

    showChat(show) {
        this.setState({showChat: show});
    }

    async startPlayer(check_url = false) {
        clearInterval(this.checkRunning);
        this.checkRunning = null;
        this.clearAllInterval();
        // ping server to check if stream is running
        console.log('startPlayer version: ' + PACKAGE_VERSION);
        try {
            const resp = await this.restMS.checkStreamEngine();
            console.log('response from the backend stream engine');
            console.log(resp);

            if (resp.running) {
                this.clearAllInterval();
                // Force a full player remount on (re)start. A stopped stream
                // leaves an ended (EXT-X-ENDLIST) HLS playlist that hls.js will
                // not resume from; on a same-name restart the link is identical,
                // so the OLD hls.js keeps showing stale data until a manual
                // refresh. Bumping playerKey rebuilds a fresh hls.js against the
                // now-live manifest — exactly what a page refresh does.
                // NOTE: we intentionally do NOT cache-bust the manifest URL.
                // The manifest keeps its shared, edge-cacheable URL (Wowza sets
                // max-age=1), and the media chunks keep their long immutable
                // cache, so caching/scaling for many viewers is preserved.
                this.source = resp.link;
                this.setState({
                    showLoader: false, showTimer: false, showPanels: false,
                    showError: false, errorId: '', streamState: 'starting',
                    playerKey: this.state.playerKey + 1
                });
            } else {
                if (!this.state.showError &&
                    (this.state.streamState === 'none' || this.state.streamState === 'timer')) {
                    this.setCheckErrorScreen("stream_completed", "inactive");
                }

                if (this.state.streamState !== 'none' && this.state.streamState !== 'timer' && this.state.streamState !== 'gotError') {
                    clearInterval(this.checkRunning);
                    clearInterval(this.checkActive);
                    this.checkRunning = null;
                    this.checkActive = null;
                    this.clearAllInterval();
                    this.checkRunning = setInterval(() => {
                        //this.startPlayer (check_url);
                        this.checkActiveStream();
                    }, 3000);
                }

                if (this.state.streamState === 'gotError') {
                    clearInterval(this.checkRunning);
                    this.checkRunning = null;
                    this.clearAllInterval();
                    this.setCheckErrorScreen("stream_error", this.state.streamState);
                    this.checkRunning = setInterval(() => {
                        this.startPlayer(check_url);
                    }, 3000);
                }
            }
        } catch (ex) {
            clearInterval(this.checkRunning);
            this.checkRunning = null;
            this.clearAllInterval();
            this.setCheckErrorScreen("stream_error", this.state.streamState);
            this.checkRunning = setInterval(() => {
                this.startPlayer(check_url);
            }, 3000);
        }
    }

    displayErrorScreen(errorId, streamState) {
        this.setState({
            showLoader: false, showTimer: false,
            showPanels: false, showError: true, errorId: errorId, streamState: streamState
        })
    }

    loadPlayerEmbedded() {
        this.setState({embeddedChecked: true})
        this.loadPlayer();
    }

    hidePlayerEmbedded() {
        this.clearAllInterval();
        this.getStreamSettings();
    }

    incrementAttemps() {
        // Note: this will *not* work as intended.
        this.setState({attempts: this.state.attempts + 1});
    }

    setCheckErrorScreen(errorId, streamState) {
        this.displayErrorScreen(errorId, streamState);
        console.log('this.maxAttempts');
        console.log(this.maxAttempts);
        console.log('this.state.attempts');
        console.log(this.state.attempts);
        if (this.maxAttempts >= this.state.attempts) {
            this.checkActiveStream();
            this.incrementAttemps();
        } else {
            this.displayErrorScreen("max_attempt_reached", streamState);
        }
    }

    // Toggle "maximize within the embed": fills the embedded area (player + chat)
    // using fixed positioning. This is NOT the browser/OS fullscreen API.
    toggleMaximize(e) {
        if (e) {
            e.preventDefault();
        }
        this.setState({maximized: !this.state.maximized});
    }

    // ms panels will pass the props
    renderPlayer() {
        console.log('renderPlayer');
        console.log('typeStreamData', this.wcdata);


        let videoAreaClass = this.state.showChat && this.props.hasChat ? "video-area" : "video-area full"
        let chatAreaClass = this.state.showChat ? "chat-area" : "chat-area compress"
        if (!this.state.showTimer && !this.state.showPanels && !this.state.showError &&
            this.state.showChat && this.props.hasChat) {
            this.props.chatMobileClass(true);
        } else {
            this.props.chatMobileClass(false);
        }
        return (
            <>
                {this.state.showTimer ?
                    <MSTimer title={this.props.jsonPayload.streamTitle} goLive={this.props.jsonPayload.goLive}
                             timeZone={this.props.jsonPayload.timeZone}/>
                    :
                    <>
                        {this.state.showPanels ?
                            <MSPanels
                                streaName={this.props.jsonPayload.streamTitle}
                                goLive={this.props.jsonPayload.goLive}
                                ecomm={this.typeStreamData.ecomm}
                                wcdata={this.typeStreamData.wcdata}
                                streamType={this.typeStreamData.streamType}
                                restMS={this.restMS}
                                externally_managed={this.props.jsonPayload.externally_managed}
                                external_access_code_page={this.props.jsonPayload.external_access_code_page}
                                loadPlayer={this.loadPlayerEmbedded}
                                hidePlayer={this.hidePlayerEmbedded}
                            />
                            :
                            <div className={"ms-player-shell" + (this.state.maximized ? " maximized" : "")}>
                                <div className={videoAreaClass}>
                                    {this.props.embedded ?
                                        <a href="#" className="ms-maximize-btn"
                                           title={this.state.maximized ? "Exit full window" : "Full window"}
                                           onClick={this.toggleMaximize}>
                                            <i className="material-icons">
                                                {this.state.maximized ? "fullscreen_exit" : "fullscreen"}
                                            </i>
                                        </a>
                                        :
                                        null
                                    }
                                    <ClapprPlayer
                                        key={this.state.playerKey}
                                        source={this.source}
                                        autoplay={this.autoLoad}
                                        restMS={this.restMS}
                                        setErrorScreen={this.setCheckErrorScreen}
                                        startPlayer={this.startPlayer}
                                    />
                                </div>
                                {this.props.hasChat ?
                                    <div className={chatAreaClass}>
                                        <TinodeWeb
                                            chnId={this.props.jsonPayload.pingId}
                                            compressChat={!this.state.showChat}
                                            showChat={this.showChat}
                                            serverAddress={this.props.serverAddress}
                                            serverSecure={this.props.serverSecure}
                                            restMS={this.restMS}
                                        />
                                    </div>
                                    :
                                    <></>
                                }
                            </div>
                        }
                    </>
                }
            </>
        );
    }

    errorCounterFinish() {
        this.setState({showLoader: true})

        this.checkActiveStream();
    }

    render() {
        let timeDiff = (this.props.jsonPayload.goLive * 1000) - Date.now();
        let isExperied = timeDiff <= -72 * 60 * 60 * 1000;

        if (isExperied || this.state.streamUnavailable) {
            return (
                <MsFeedbackMessage
                    title={this.state.unavailableTitle}
                    message={this.state.unavailableMessage}
                    wclass="unavailable"
                    subTitle={null}
                    bottomComponent={null}
                />
            );
        }

        if (this.state.showLoader || this.state.showError) {
            this.props.chatMobileClass(false);
        }

        //return this.renderPlayer();

        return (
            <>
                {this.state.showLoader ?
                    <MSStreamLoader
                        divId="player_container_emb"
                    />
                    :
                    <>
                        {this.state.showError ?
                            <MSStreamError
                                errorType={this.state.errorId}
                                callback={this.errorCounterFinish}
                            />
                            :
                            this.renderPlayer()
                        }
                    </>
                }
            </>
        )
    }
}

export default injectIntl(MsVideoPlayer);
